import type { AxiosResponse } from 'axios';

import type { PostFormData } from 'Modules/prepareFormData';
import type { FetchResult } from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard/hooks/types';
import type {
    LoginWithPasswordReturn,
    PostLoginByPasswordPayload,
} from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard/hooks/useLogin/types';

type TwoFactorEvent = 'shown' | 'resend';

type TwoFactorEventResponse = AxiosResponse<FetcherPostApi['/account/login/two_factor_event']['response']>;
type TwoFactorEventData = TwoFactorEventResponse['data'];

export enum TwoFactorEventDataResponseKey {
    Unknown = 'UNKNOWN',
}

export interface PostTwoFactorEventPayload extends PostFormData {
    username: string;
    event: TwoFactorEvent;
}
export type PostTwoFactorEventResult = FetchResult<TwoFactorEventData>;

export type SendTwoFactorCodeParams = PostTwoFactorEventPayload;
export type SendTwoFactorCodeReturn = PostTwoFactorEventResult;

export type PostTwoFactorEventResendPayload = PostLoginByPasswordPayload & { resend_code_2fa?: boolean };

export type ResendTwoFactorCodeParams = PostLoginByPasswordPayload;
export type ResendTwoFactorCodeReturn = LoginWithPasswordReturn;
